import React, { useContext } from "react";
import { Form, Input, Button, Space, notification } from "antd";
import { useMediaQuery } from "react-responsive";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { MainLayout } from "../../layouts";
import AppTheme from "../../theme/AppTheme";
import { Link } from "react-router-dom";
import { Backend } from "../../helpers";
import { authContext } from "../../providers";
import { Store } from "antd/lib/form/interface";
import { AxiosResponse } from "axios";
import { ILoginResponse } from "../../interfaces";

const Login: React.FC = (props) => {
  // load auth context
  const authCtxt = useContext(authContext);

  const onFinish = (values: Store) => {
    // loading
    authCtxt.dispatch({ type: "startLoading" });
    // authenticate
    Backend.getInstance()
      .axios()
      .post("/api/loginuser/", values)
      .then((response: AxiosResponse<ILoginResponse>) => {
        console.log(response.data);
        // notify the user
        notification.success({
          message: `Successfully connected`,
          placement: "topRight",
        });

        // update auth data
        authCtxt.updateAuth({
          data: response.data,
        });
      })
      .catch((error) => {
        console.log("error", error.data);
        // notify the user
        notification.error({
          message: `Login failed`,
          description:
            "Failed to login. Check your credentials and try again later please.",
          placement: "topRight",
        });
      })
      .finally(() => {
        authCtxt.dispatch({ type: "stopLoading" });
      });
  };

  const isMd = useMediaQuery({ query: "(max-width: 768px)" });
  const isSm = useMediaQuery({ query: "(max-width: 640px)" });

  return (
    <MainLayout>
      <div className="w-full flex items-center">
        <div className="inline-block m-auto">
          <Space
            className="flex-auto"
            size="large"
            direction={isMd ? "vertical" : "horizontal"}
          >
            <div
              className="block sm:inline-block w-full"
              style={{ width: isSm ? "100%" : "340px" }}
            >
              <h1 className="font-bold text-4xl pb-8 pt-16 text-gray-600">
                Sign In
              </h1>
              <div className="block w-full">
                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Username!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined className="site-form-item-icon" />}
                      size="large"
                      placeholder="Username"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      placeholder="Password"
                    />
                  </Form.Item>
                  <Form.Item className="text-right">
                    <Link className="login-form-forgot" to="/forget-password">
                      Forgot{" "}
                      <span style={{ color: AppTheme.colors.primary }}>
                        username
                      </span>{" "}
                      or{" "}
                      <span style={{ color: AppTheme.colors.primary }}>
                        password
                      </span>
                      ?
                    </Link>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      size="large"
                      type="primary"
                      htmlType="submit"
                      className="w-full rounded-md text-xs font-bold uppercase"
                    >
                      Sign In
                    </Button>
                    <Link to="/register">
                      <Button
                        type="default"
                        htmlType="button"
                        size="large"
                        className="w-full rounded-md text-xs font-bold uppercase my-3"
                      >
                        Create Account
                      </Button>
                    </Link>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

export default Login;
